import { useState } from "react";
import Map from "../core/Map";
import ListingPropertyMarker from "../listings/ListingPropertyMarker";

import { Listing, SummaryListing } from "src/types/listing";
import { GeoLocation } from "src/types/common";

const SearchPageMap = ({
  listings,
  mapCenter,
  selectedListing,
  onMarkerClick,
  suppressPriceInDetailsPanel = false,
  isHideDNCPhoneNumbers,
}: {
  listings: SummaryListing[];
  mapCenter: GeoLocation;
  selectedListing: Listing | null;
  onMarkerClick: (listing: SummaryListing) => void;
  suppressPriceInDetailsPanel?: boolean;
  isHideDNCPhoneNumbers?: boolean;
}) => {
  const [hoveredListingId, setHoveredListingId] = useState<number | null>(null);

  const noLocationMessage = selectedListing?.title ? (
    <>
      No location data for
      <br />
      <span className="font-semibold">{selectedListing.title}</span>
    </>
  ) : (
    "No location data available"
  );

  return (
    <Map mapCenter={mapCenter} noLocationMessage={noLocationMessage}>
      <>
        {listings
          ?.filter((listing) => listing?.geolocation?.lat && listing?.geolocation?.lng)
          .map((listing) => {
            return (
              <ListingPropertyMarker
                listingId={listing.id}
                productType={listing.productType}
                isSelected={`${selectedListing?.id}` === `${listing.id}`}
                key={listing.id}
                position={{
                  lat: listing.geolocation?.lat || 0,
                  lng: listing.geolocation?.lng || 0,
                }}
                onClick={() => {
                  onMarkerClick(listing);
                }}
                isHovered={hoveredListingId === parseInt(listing.id)}
                onMouseOver={() => {
                  setHoveredListingId(parseInt(listing.id));
                }}
                onMouseOut={() => {
                  setHoveredListingId(null);
                }}
                isHideDNCPhoneNumbers={isHideDNCPhoneNumbers}
              >
              </ListingPropertyMarker>
            );
          })}
      </>
    </Map>
  );
};

export default SearchPageMap;
